module.exports = __webpack_public_path__ + "img/win2.d70fa54c.png";